import * as nuxtUtils from '../../utils/nuxt-utils'
import { NuxtMiddleware, Context } from './nuxt-middleware'

/**
 default nuxt module
  1) error를 감지하여 error 화면으로 redirect
  2) context의 option을 조회하여 context 객체로 pass
 @packageDocumentation
 */

export default {
  name: 'default',
  middleware: async (context: Context) => {
    // server 오류 처리
    if (context.$ustra.definedStore.core.serverError) {
      const serverError = context.$ustra.definedStore.core.serverError

      context.error({ statusCode: serverError.status ? serverError.status : 500, message: serverError.message })
      return
    }

    // component로 부터 옵션을 조회한다.
    const option = nuxtUtils.getRouteOption(context.route)
    if (option && option.config) {
      context.app.config = context.$ustra.utils.core.deepMerge({}, option.config)
    } else {
      context.app.config = {}
    }
  },
} as NuxtMiddleware
